module.exports = __webpack_public_path__ + "static/media/DinersClub.441fd17a.svg";